import { render, staticRenderFns } from "./room-modal.vue?vue&type=template&id=22a74dce"
import script from "./room-modal.vue?vue&type=script&lang=js"
export * from "./room-modal.vue?vue&type=script&lang=js"
import style0 from "./room-modal.vue?vue&type=style&index=0&id=22a74dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports